module.exports = __webpack_public_path__ + "img/img5.dd876fa3.jpg";